import { render, staticRenderFns } from "./ProspectiveTableHead.vue?vue&type=template&id=2c250446&"
import script from "./ProspectiveTableHead.vue?vue&type=script&lang=js&"
export * from "./ProspectiveTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports